import { render } from "./AboHistoryDialog.vue?vue&type=template&id=0ab4b0be"
import script from "./AboHistoryDialog.vue?vue&type=script&lang=js"
export * from "./AboHistoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__